import { render, staticRenderFns } from "./RedMultiselect.vue?vue&type=template&id=468301e8"
import script from "./RedMultiselect.vue?vue&type=script&lang=js"
export * from "./RedMultiselect.vue?vue&type=script&lang=js"
import style0 from "./RedMultiselect.vue?vue&type=style&index=0&id=468301e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports